import { auth, type SchemaResponse } from "@/modules/api"
import type { Campaign } from "@/modules/types"
import type { PagingSchema } from "@/modules/types/common/schema"

type FetchCampaignExplore = {
  page?: number
  take: number
  filterBy?: string | string[]
  type?: string
  nextPageToken?: string
  order?: "ASC" | "DESC"
  startCommissionRate?: string
  endCommissionRate?: string
  haveCast?: boolean
  isSelfFaceRequired?: boolean | null
}

export const getCampaignExplore = ({
  nextPageToken,
  take,
  filterBy,
  type,
  order = "DESC",
  startCommissionRate,
  endCommissionRate,
  haveCast,
  isSelfFaceRequired
}: FetchCampaignExplore) => {
  let params: any = {
    limit: take,
    order,
    sortBy: "updatedAt"
  }

  const filterValue = filterBy ?? type
  if (filterValue && (Array.isArray(filterValue) ? filterValue.length > 0 : true)) {
    params = { ...params, filterBy: filterValue }
  }

  if (startCommissionRate) {
    params = { ...params, startCommissionRate }
  }

  if (endCommissionRate) {
    params = { ...params, endCommissionRate }
  }

  if (typeof haveCast === "boolean") {
    params = { ...params, haveCast }
  }

  if (typeof isSelfFaceRequired === "boolean") {
    params = { ...params, isSelfFaceRequired }
  }

  if (nextPageToken) {
    params = { ...params, nextPageToken }
  }

  const paramsSerializer = (params: Record<string, any>): string => {
    return Object.entries(params)
      .map(([key, value]) => {
        if (Array.isArray(value)) {
          // Xử lý mảng: tạo chuỗi `type=NEW_CAMPAIGN&type=CREATE_DRAFT`
          return value.map((v) => `${key}=${encodeURIComponent(v)}`).join("&")
        }
        return `${key}=${encodeURIComponent(value)}`
      })
      .join("&")
  }

  const url = "v1/campaign/explore?"
  const queryString = paramsSerializer(params)
  return auth.get<SchemaResponse<PagingSchema<Campaign>>>(url + queryString)
}
